import { HStack, Text, useColorModeValue } from "@chakra-ui/react";
import GarrettButton from "./GarrettButton";
import HeartIcon from "./HeartIcon";
import KellyanButton from "./KellyanButton";

export default function FooterRight() {
  const textColor = useColorModeValue("#4b635e", "#E9A6A6");
  const year = new Date().getFullYear();

  return (
    <HStack spacing="12px">
      <GarrettButton />
      <HeartIcon />
      <KellyanButton />
      <Text color={textColor} fontFamily="Lilita One" fontSize="xl">
        {year}
      </Text>
    </HStack>
  );
}
